import React, { useState } from 'react';
import styled from 'styled-components';
import { _ } from '_locales';
import { goToTop } from '_helpers';
import { connect } from 'react-redux';
import MMDetails from './components/MMDetails';
import MMCarousel from './components/MMCarousel';
import eventTracker from '../../../helpers/eventTracker';
import events from '../events';
import { Arrow } from '../../../styles/common-styles';

const MisunderstoodMaterial = ({
  misunderstood_materials,
  setDisplayedContent,
  windowsWidth,
  setRef
}) => {
  const [mmMaterialIndex, setMmMaterialIndex] = useState(0);
  const [showMmMaterialDetails, setShowMmMaterialDetails] = useState();

  const mmMaterialClickHandler = () => {
    setShowMmMaterialDetails(true);
    setDisplayedContent('misunderstoodMaterial');
    eventTracker(events.HOME_SCREEN_MISUNDERSTOOD_MATERIAL_CTA_TAP, '');
    goToTop();
  };
  const goBackHandler = () => {
    setShowMmMaterialDetails(false);
    setDisplayedContent();
    goToTop();
    setRef('MMRef');
  };
  const nextMMHandler = () => {
    setMmMaterialIndex((prevState) => prevState + 1);
    goToTop();
  };
  const prevoiousMMHandler = () => {
    setMmMaterialIndex((prevState) => prevState - 1);
    goToTop();
  };

  return (
    <Container>
      <Title>
        {showMmMaterialDetails && (
          <Arrow background="#fff" onClick={goBackHandler} aria-label="Go back">
            &#8678;
          </Arrow>
        )}
        {showMmMaterialDetails
          ? misunderstood_materials[mmMaterialIndex].mat_nm : _('education.misunderstood_materials')}
      </Title>

      {showMmMaterialDetails ? (
        <MMDetails
          misunderstood_materials={misunderstood_materials}
          mmMaterialIndex={mmMaterialIndex}
          prevoiousMMHandler={prevoiousMMHandler}
          nextMMHandler={nextMMHandler}
          key={mmMaterialIndex}
        />
      ) : (
        <MMCarousel
          mmMaterialIndex={mmMaterialIndex}
          misunderstood_materials={misunderstood_materials}
          setMmMaterialIndex={setMmMaterialIndex}
          mmMaterialClickHandler={mmMaterialClickHandler}
          windowsWidth={windowsWidth}
        />
      )}
    </Container>
  );
};

export default connect(
  (store) => ({
    misunderstood_materials: store.education.misunderstood_materials,
    selectedLang: store.config.selectedLang
  })
)(MisunderstoodMaterial);

const Container = styled.div`
  box-sizing: border-box;
  padding: 10px 0;
  padding-top: 5px;
  background-color: white;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 18px 0px;
  margin-top: 15px;
  overflow: hidden;
  position: relative;
`;

const Title = styled.h2`
  display:flex;
  align-items: center;
  font-size: 18px !important;
  color: rgba(64, 64, 64, 1);
  font-weight: 700 !important;
  border-bottom: 2px solid #E7ECEF;
  padding-bottom: 10px !important;
  padding-left: 10px !important;
  margin-top: 10px !important;
`;
